export const decodeTokenExpiration = (token) => {
    if (!token || typeof window === 'undefined' || typeof window.atob !== 'function') {
        return null;
    }

    try {
        const base64Url = token.split('.')[1];
        if (!base64Url) {
            return null;
        }

        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(window.atob(base64).split('').map((char) => {
            return `%${(`00${char.charCodeAt(0).toString(16)}`).slice(-2)}`;
        }).join(''));

        const payload = JSON.parse(jsonPayload);
        const expValue = Number(payload?.exp);
        if (!Number.isFinite(expValue)) {
            return null;
        }

        return expValue * 1000;
    } catch (error) {
        console.warn('Failed to decode token expiration', error);
        return null;
    }
};

export const persistToken = (token, expiresAt) => {
    if (token) {
        localStorage.setItem('authToken', token);
    } else {
        localStorage.removeItem('authToken');
    }

    if (expiresAt) {
        localStorage.setItem('tokenExpiresAt', String(expiresAt));
    } else {
        localStorage.removeItem('tokenExpiresAt');
    }
};
